/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelectVariantRequestPost } from '../../models/select-variant-request-post';
import { SelectVariantResponse } from '../../models/select-variant-response';

export interface VariantsControllerSelectVariant$Params {
      body: SelectVariantRequestPost
}

export function variantsControllerSelectVariant(http: HttpClient, rootUrl: string, params: VariantsControllerSelectVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectVariantResponse>> {
  const rb = new RequestBuilder(rootUrl, variantsControllerSelectVariant.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelectVariantResponse>;
    })
  );
}

variantsControllerSelectVariant.PATH = '/planning-projects/v1-develop/projects/variants/select';
